import { ZodError } from 'zod'

/**
 * Formats a ZodError into a readable string.
 * Each error is formatted as "path: message" and joined by semicolons.
 *
 * @param {ZodError} error - The ZodError to format.
 * @returns {string} - A formatted string representing the ZodError.
 */
export function formatZodError(error: ZodError): string {
  return error.issues
    .map((e) => `${e.path.join(' > ')}: ${e.message}`)
    .join('; ')
}
